import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, flatMap } from 'rxjs/operators';
import * as fromShared from '../../../shared';
import * as QueueJobActions from './queue-job.actions';
import { InternalAdminService } from '../../internal-admin.service';

@Injectable()
export class QueueJobEffects {
    constructor(
        private actions$: Actions,
        private service: InternalAdminService
    ) {}

    post$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(QueueJobActions.postQueueJob),
            concatMap(a =>
                this.service
                    .postQueueJob(
                        a.employeelistid,
                        a.customerid,
                        a.jobid,
                        a.storedproc
                    )
                    .pipe(
                        flatMap(resp => [
                            QueueJobActions.loadQueueJobs({
                                QueueJobs: [{
                                    jobid: a.jobid,
                                    customerid: a.customerid,
                                    responsemessage: resp
                                }]
                            })
                        ]),
                        catchError(fromShared.Errors.handleServiceError)
                    )
            )
        );
    });
}
